import { AccessGuids, ConfigSystemParams, DgActionColumnWidth, DgAlignment, DgColumnChooserMode, DgEditingMode, DgExportFormat, DgFormLabelLocation, DgPagerDisplayMode, DgPagerScrollingMode, DgPopupDefaults, DgSelectionCheckBoxMode, DgSelectionMode, DgSummaryType } from "../../consts";
import { AuthenticationService } from '../../services/auth.service';
import { ColumnChooserMode, GridsEditMode, PagerDisplayMode } from 'devextreme/common/grids';
import { Component } from "@angular/core";
import { ComponentAccessUserService } from '../../services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from '../../services/utelize/system/config-system/config-system-service';
import { DgActionColumn } from "../../interfaces/datagrid/dg-action-column";
import { DgApiPath } from "../../interfaces/datagrid/dg-api-paths";
import { DgCheckbox } from "../../interfaces/datagrid/dg-check-box";
import { DgColumn, DgColumnValidation } from '../../interfaces/datagrid/dg-column';
import { DgPopup } from "../../interfaces/datagrid/dg-pop-up";
import { DgProperties } from "../../interfaces/datagrid/dg-properties";
import { DgTab } from 'src/app/core/interfaces/datagrid/dg-tab';
import { ExceptionsService } from "../../services/utelize/general/exceptions-service";
import { LabelLocation } from 'devextreme/ui/form_types';
import { ValidationRuleType } from 'devextreme/common';

@Component({
  standalone: true,
  template: ``,
})
export class GridViewDefaults {

  get gridShowAll() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowAll, false) ||
                             this.componentAccessUserService.hasAccessGuid(AccessGuids.GridShowAll,     true ) ; }

  get gridSearchPanelWidthPx() {
    try {
      const configured: number=this.configSystemService.getValueAsInteger(ConfigSystemParams.GridSearchPanelWidthPx, 0);
      return configured>0 ? configured : 200;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 200;
    }
  }

  constructor(
    private authenticationService     : AuthenticationService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private exceptionsService         : ExceptionsService
  ) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setUpDgApiPaths(apiPath: string): DgApiPath | undefined {
    try {
      let dgApiPath: DgApiPath = {
        delete: apiPath,
        get   : apiPath,
        post  : apiPath,
        put   : apiPath,
      }

      return dgApiPath;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public setUpDgActionColumn(): DgActionColumn | undefined {
    try {
      let dgActionColumn: DgActionColumn = {
        allowAdding                     : false,
        allowDeleting                   : true,
        allowLocation                   : false,
        allowMessage                    : false,
        allowMore                       : false,
        allowRisk                       : false,
        allowStatement                  : false,
        allowUndelete                   : false,
        allowUpdating                   : true,
        caption                         : "Actions",
        cellTemplate                    : undefined,
        deleteButtonDisabledHint        : "",
        deleteRowButtonCondition        : (data:any) => {return true;},
        deleteRowButtonDisabledCondition: (data:any) => {return false;},
        deleteIcon                      : "assets/images/_suresim/Button Delete 55x23.png",
        fixed                           : false,
        fixedPosition                   : "right",
        locationIcon                    : "assets/images/_suresim/Button Location 55x23.png",
        locationRowButtonCondition      : (data:any) => {return true;},
        messageIcon                     : "email",
        messageRowButtonCondition       : (data:any) => {return true;},
        minWidth                        : undefined,
        mode                            : <GridsEditMode>DgEditingMode.popup,
        moreRowButtonCondition          : (data:any) => {return true;},
        moreIcon                        : "assets/images/_suresim/Button More 55x23.png",
        overrideDelete                  : false,
        riskRowButtonCondition          : (data:any) => {return true;},
        showInColumnChooser             : false,
        statementIcon                   : "assets/images/_suresim/Button Statement 55x23.png",
        statementRowButtonCondition     : (data:any) => {return true;},
        undeleteIcon                    : "assets/images/_suresim/Button Restore 55x23.png",
        undeleteRowButtonCondition      : (data:any) => {return false;},
        updateIcon                      : "assets/images/_suresim/Button Edit 55x23.png",
        updateRowButtonCondition        : (data:any) => {return true;},
        useIcons                        : true,
        visible                         : true,
        width                           : DgActionColumnWidth.twoButtonsWithLeftRightPadding,
      }
      
      return dgActionColumn;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public setUpDgPopup(popUpTitle: string): DgPopup | undefined {
    try {
      let dgPopup: DgPopup = {
        colSpan            : DgPopupDefaults.colSpan,
        disabled           : false,
        dragOutsideBoundary: false,
        footerText         : undefined,
        height             : DgPopupDefaults.height,
        helpText           : "",
        hideOnOutsideClick : false,
        labelLocation      : <LabelLocation>DgFormLabelLocation.top,
        overridePopup      : false,
        shading            : false,
        showCloseButton    : false,
        showColon          : false,
        showTitle          : true,
        title              : popUpTitle,
        width              : DgPopupDefaults.width,
      }

      return dgPopup;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public setUpDgProperties(title: string, exportFilenameSuffix: string): DgProperties | undefined {
    try {
      let dgProperties: DgProperties = {
        addButtonHint             : undefined,
        allowColumnReordering     : true,
        allowColumnResizing       : true,
        allowedPageSizes          : [5, 10, 15, 20, 50, (this.gridShowAll ? "all" : "")],
        allowExportSelectedData   : true,
        apiMethodOverrideGet      : undefined,
        autoNavigateToFocusedRow  : true,
        button1Options            : undefined,
        cacheEnabled              : false,
        checkbox0                 : undefined,
        checkbox1                 : undefined,
        columnAutoWidth           : false,
        columnChooser             : true,
        columnChooserMode         : <ColumnChooserMode>DgColumnChooserMode.select,
        columnChooserSort         : false,
        columnFixing              : true,
        columnHidingEnabled       : false,
        columnMinWidth            : undefined,
        // encryptDelete             : false,
        encryptDeleteSS           : false,
        encryptPost               : false,
        encryptPut                : false,
        errorReplaceIf            : undefined,
        errorReplacement          : "Error replacement has not been set",
        errorSuppressIf           : undefined,
        export                    : true,
        exportFilenameSuffix      : exportFilenameSuffix,
        exportFormat              : [DgExportFormat.pdf, DgExportFormat.xlsx],
        filterRow                 : true,
        focusedRowEnabled         : true,
        focusedRowUnselect        : true,
        headerFilter              : true,
        height                    : undefined,
        highlightSearchText       : true,
        hoverStateEnabled         : true,
        initialTab                : 1,
        loadPanel                 : true,
        loadPanelShowIndicator    : true,
        loadPanelShowPane         : true,
        loadPanelText             : "Loading...",
        masterDetail              : false,
        masterDetailCaption1      : "",
        masterDetailCaption1Show  : false,
        masterDetailCaption2      : "",
        masterDetailCaption2Show  : false,
        pagerDisplayMode          : <PagerDisplayMode>DgPagerDisplayMode.adaptive,
        pagershowInfo             : true,
        pagerVisible              : true,
        pageSize                  : 50,
        paging                    : true,
        remoteOperations          : false,
        rowDraggingAllowReordering: true,
        rowDraggingShowDragIcons  : this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowDragIcons, false),
        rowRightClickEmitOnly     : false,
        scrollingMode             : DgPagerScrollingMode.standard,
        searchPanel               : true,
        searchPanelWidth          : this.gridSearchPanelWidthPx,
        searchVisibleColumnsOnly  : false,
        selectionCheckBoxMode     : DgSelectionCheckBoxMode.none,
        selectionMode             : DgSelectionMode.multiple,
        showAddButton             : true,
        showBorders               : true,
        showColumnHeaders         : true,
        showColumnLines           : true,
        showPageSizeSelector      : true,
        showRefreshButton         : false,
        showRowLines              : false,
        showScrollbar             : true,
        showTabs                  : false,
        title                     : title,
        useDevExtremePopupForm    : false
      }

      return dgProperties;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public setUpDgColumn(dataField: string,
                       caption  : string,
                       value    : boolean | string | null | number,
                       dataType : string): DgColumn | undefined {
    try {
      let dgColumn: DgColumn = {
        alignment             : DgAlignment.left,
        allowFiltering        : true,
        allowFixing           : false,
        allowSearch           : true,
        allowSorting          : true,
        autoWidth            : false,
        avatarClickable       : false,
        calculateCellValue    : undefined,
        calculateDisplayValue : undefined,
        calculateSortValue    : undefined,
        caption               : caption,
        captionExtra          : undefined,
        cellIcon              : undefined,
        cellTemplate          : undefined,
        cellTemplateCondition : (data:any) => {return true;},
        cellTemplateIcon      : undefined,
        cellTemplateType      : undefined,
        customizeText         : undefined,
        dataField             : dataField,
        dataSource            : undefined,
        dataSourceDisplayField: "description",
        dataSourceForAForm    : undefined,
        dataSourceLookupField : "id",
        dataType              : dataType,
        falseText             : "No",
        filterPlaceholder     : undefined,
        filterValue           : undefined,
        filterValues          : undefined,
        fixed                 : false,
        fixedPosition         : "left",
        format                : undefined,
        formEnabled           : true,
        formValidationRules   : [],
        formVisible           : true,
        gridVisible           : true,
        headerFilter          : undefined,
        hidingPriority        : undefined,
        imageColumn           : undefined,
        lastDataSource        : false,
        minWidth              : undefined,
        ourDate               : undefined,
        placeholder           : undefined,
        readOnly              : false,
        selectedFilterOperation : undefined,
        sendToDB              : true,
        setCellValue          : {},
        showInColumnChooser   : true,
        sortIndex             : undefined,
        sortOrder             : undefined,
        summaryType           : DgSummaryType.none,
        summaryValueFormat    : undefined,
        trueText              : "Yes",
        validators            : [],
        value                 : value,
        valueAddOnInitNewRow  : true,
        visibleIndex          : undefined,
        width                 : undefined
      }

      return dgColumn;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public setUpDgCheckbox(title   : string,
                         onValue : string | number | boolean,
                         offValue: string | number | boolean,
                         value   : string | number | boolean,
                         visible : boolean): DgCheckbox | undefined {
    try {
      let dgCheckbox: DgCheckbox={
        offValue: offValue,
        onValue : onValue,
        title   : title,
        value   : value,
        visible : visible,
      }

      return dgCheckbox;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public setUpDgColumnMobile(dataField: string,
                             caption  : string): DgColumn | undefined {
    try {
      let dgColumn: DgColumn | undefined=this.setUpDgColumn(dataField, caption, "", "string");

      if (dgColumn != undefined
          && this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUserUseInternationalDialCode, false)) {
        dgColumn.calculateCellValue=(rowData: any) => {
          const e164  : string=rowData?.mobileE164;
          const stored: string=rowData?.[dataField];

          return (e164 != null && e164 != undefined && e164.trim() != "") ? e164 : stored;
        };
      }

      return dgColumn;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public setUpDgTab(id:number,
                    name: string): DgTab | undefined {
    try {
      let dgTab: DgTab = {
        id               : id,
        name             : name
      }

      return dgTab;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public setValRule(validationRuleType: ValidationRuleType,
                    minLength?        : number | undefined,
                    maxLength?        : number | undefined
  ): DgColumnValidation | undefined {
    try {
      let dgColumnValidation: DgColumnValidation = {
        rule: validationRuleType,
        min : minLength,
        max : maxLength
      };

      return dgColumnValidation;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }
}
